// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemNext_wrapper__JUdSG"};